import { render, staticRenderFns } from "./SecuriteBox.vue?vue&type=template&id=8ad92e98&scoped=true&"
import script from "./SecuriteBox.vue?vue&type=script&lang=js&"
export * from "./SecuriteBox.vue?vue&type=script&lang=js&"
import style0 from "./SecuriteBox.vue?vue&type=style&index=0&id=8ad92e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad92e98",
  null
  
)

export default component.exports